var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdateWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.25 19.19-1.5-1.5v-1.94h-1.5v2.56l1.94 1.94 1.06-1.06z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 23.25a5.25 5.25 0 1 1 0-10.5 5.25 5.25 0 0 1 0 10.5zm0-9a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5zM12 21a9.01 9.01 0 0 1-9-9H1.5A10.512 10.512 0 0 0 12 22.5V21zM9 6H5.309A8.988 8.988 0 0 1 21 12h1.5a10.483 10.483 0 0 0-18-7.324V1.5H3v6h6V6z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateWhite);
export default __webpack_public_path__ + "static/media/update_white.5d9042ccd10109544f3b06570383e7ca.svg";
export { ForwardRef as ReactComponent };